import React from "react";
import { Outlet } from "react-router-dom";

import "./styles.scss";
import Navbar from "../../../components/Navbar";

const Dashboard: React.FC = () => {
  return (
    <div className="dashboard-container">
      <Navbar />
      <Outlet />
    </div>
  );
};

export default Dashboard;
